var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-button',{attrs:{"size":"small","icon":"delete","type":"danger","ghost":""},on:{"click":function($event){return _vm.$emit('click')}}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/.pnpm/vue-loader@13.7.3_i2o4bjsec3mu56akmuw42haohq/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c8c67ba","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/.pnpm/vue-loader@13.7.3_i2o4bjsec3mu56akmuw42haohq/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/table/ActionDelete.vue
// module id = null
// module chunks = 